import { combineReducers } from 'redux';
import FaturamentoReducer from './FaturamentoReducer';
import PedidoReducer from './PedidoReducer';

export default combineReducers({
    faturamento: FaturamentoReducer,
    pedido: PedidoReducer
});